module.exports = __webpack_public_path__ + "img/page_info_join.46363a1.svg";